import React from 'react';
import { FlagOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventName } from '../../../section/Common/constants';
import { SOURCE } from '../../../core/constants';

interface IProps {
  book: IBook;
  id: string;
  label?: string;
}

const Exclude: React.FC<IProps> = ({ book, id, label = 'Title' }) => {
  const { setAction } = useActions();
  const SOURCE_TO_IDENTIFIER: Record<string, string> = {
    [SOURCE.bookstat]: 'ASIN',
    [SOURCE['royal-road']]: 'Fiction Id',
    [SOURCE.ao3]: 'work_id'
  };
  const identifierValue = book[SOURCE_TO_IDENTIFIER[id] ?? 'ASIN'];

  return (
    <Popover
      placement='topLeft'
      content={
        <div className='popover-content'>{`Send ${label} to Exclusion List`}</div>
      }
      trigger='hover'
    >
      <FlagOutlined
        data-testid='action-exclusion-list'
        onClick={(e) => {
          e.stopPropagation();
          window.gtag('event', GAEventName.click,
            { identifier: ACTIONS.exclude, value: identifierValue, book_name: book.Title });
          setAction({ book, id, type: ACTIONS.exclude });
        }}
        className='actions-icons actions-icons-flag'
      />
    </Popover>
  );
};

export default React.memo(Exclude);